<template>
  <div class="events">
    <nav class="top-navbar">
        <div class="title">
            <div class="title-inner">
                <span class="title-inner-name" v-i18n="'MN_CALENDAR'" />
            </div>
        </div>
        <div class="icon-right">
            <router-link to="/events/add" class="bordered-icon btn-start-recording" :title="$hisport.i18n('START_REC')">
              <font-awesome-icon :icon="['fas','stopwatch']"/>
            </router-link>
            <help/>
        </div>
    </nav>
    <!-- <div class="hg-filter" v-if="events.length>0">
      <div class="hg-filter-block">
        <select class="hg-select" v-model="filter.team"  :class="{'has-value': !!filter.team}">
          <option value="" v-i18n="'ALL_TEAMS'"></option>
          <option v-for="t in teams" :key="t.id" :value="t.id">
            {{t.name}}
          </option>
        </select>
      </div>
      <div class="hg-filter-block">
        <select class="hg-select" v-model="filter.season" :class="{'has-value': !!filter.season}">
          <option value="" v-i18n="'ALL_SEASONS'"></option>
          <option v-for="t in seasons" :key="t.id" :value="t.id">
            {{t.name}}
          </option>
        </select>
      </div>
    </div> -->
    <events-table   :list="events" v-if="loaded" :hide-columns="['video']"/>
  </div>
</template>
<script>
import eventsTable from "../_components/event_table"
import help from "../_components/help"
export default {
  title: "MN_CALENDAR",
  components: {eventsTable, help},
  beforeDestroy(){
    clearInterval(this.interval);
  },
  mounted(){
    this.interval = setInterval(this.load, 30000)
    this.load();
  },
  data(){
      return {
        interval: null,
        loaded: false,
        events: [],
        teams: [],
        seasons: []
      }
  },
  methods:{
    load(){
      var self = this;
      this.$hisport.datacontext.event.getByUserId(this.$hisport.getUserId(), {
        filter: {"start_timestamp": { $gte: new Date().toJSON() }},
        sort: [{field: "start_timestamp", type: "desc"}], 
        include: ["teams", "video", "logo", "game_field"]
      })
      .then(function(events){
        // if(events.length==0 && self.$hisport.permissions.isAdmin()){
        //     self.$router.push("/events/all");
        // }
        self.events   = events;
        self.teams    = events.reduce(function(acc, evt){
                          if(evt.team_home && !acc.find(x=>x.id == evt.id_team_home))
                            acc.push({
                              id: evt.id_team_home,
                              name: evt.team_home.name
                            })
                          if(evt.id_team_foreign && evt.team_foreign && !acc.find(x=>x.id == evt.id_team_foreign))
                            acc.push({
                              id: evt.id_team_foreign,
                              name: evt.team_foreign.name
                            })
                          return acc;
                        }, []);
        self.seasons  = events.reduce(function(acc, evt){
                          if(!acc.find(x=>x.id == evt.id_season))
                            acc.push({
                              id: evt.id_season,
                              name: evt.name_season
                            });
                          return acc;
                        }, []);
        self.loaded = true;
        self.$store.dispatch("setLoading", false);
      })
      
    }
  }
}
</script>
<style scoped>
 .events .team_logo{
   width:20px;
 }
</style>